"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaSizes = exports.mediaFn = exports.mediaMin = exports.getMediaVal = exports.calcMediaVal = exports.mediaMaxC = exports.mediaMinC = exports.getCssMedia = void 0;
const styled_components_1 = require("styled-components");
const oxygen_constants_1 = require("@8x8/oxygen-constants");
const mediaSizes = {
    desktop: oxygen_constants_1.size.windowWidthDesktop,
    tablet: oxygen_constants_1.size.windowWidthTablet,
    phone: oxygen_constants_1.size.windowWidthPhone,
};
exports.mediaSizes = mediaSizes;
/**
 * @description Convert pixels to em units
 * @param {(number|string)} value Breakpoint value
 * @returns {number} A number which was converted to em units
 */
const calcMediaVal = (value) => parseFloat(value) / 16;
exports.calcMediaVal = calcMediaVal;
/**
 * @description Append `em` to a number
 * @param {number} value Breakpoint value
 * @returns {string} A number which was converted to em units with `em` appended
 */
const getMediaVal = (value) => `${calcMediaVal(value)}em`;
exports.getMediaVal = getMediaVal;
/**
 * @param {string} [mediaRule=max] Prefix for the media rule: [min|max]
 * @returns {(value: (number|string)) => (...args: string) => string}
 */
const getCssMedia = (mediaRule = 'max') => (value) => 
// disable-next-line @typescript-eslint/no-explicit-any
(...args) => (0, styled_components_1.css) `
      @media (${mediaRule}-width: ${getMediaVal(value)}) {
        ${(0, styled_components_1.css)(args)}
      }
    `;
exports.getCssMedia = getCssMedia;
/**
 * description Function to create an object containing media query functions for `styled-components`
 * param {{ desktop: number, tablet: number, phone: number }} [sizeEntries]
 * returns { (string) =>  { desktop: Function, tablet: Function, phone: Function }} - Utility media-query functions
 * for `styled-components`
 */
const mediaFn = (sizeEntries = mediaSizes) => 
/**
 * @param {'min' | 'max'} [mediaRule='max'] Media query [max|min] width rule
 */
(mediaRule = 'max') => ({
    desktop: getCssMedia(mediaRule)(sizeEntries.desktop),
    tablet: getCssMedia(mediaRule)(sizeEntries.tablet),
    phone: getCssMedia(mediaRule)(sizeEntries.phone),
});
exports.mediaFn = mediaFn;
/**
 * @description Creates a min-width rule with custom value
 * @param {(number|string)} value Breakpoint value
 * @returns {(css: string) => string}
 */
const mediaMinC = getCssMedia('min');
exports.mediaMinC = mediaMinC;
/**
 * @description Creates a max-width rule with custom value
 * @param {(number|string)} value Breakpoint value
 * @returns {(css: string) => string}
 */
const mediaMaxC = getCssMedia();
exports.mediaMaxC = mediaMaxC;
/**
 * @description Object containing `min-width` breakpoint functions for `styled-components`
 */
const mediaMin = mediaFn()('min');
exports.mediaMin = mediaMin;
/**
 * @description Object containing `max-width` breakpoint functions for `styled-components`
 */
const mediaMax = mediaFn()();
exports.default = mediaMax;
